import { Fragment, useEffect, useRef } from "react";
import cookie from 'react-cookies';
import WEBSOCKET_HOST from "../../../settings/ws.host";

const WebSockets = ({ actions }) => {
  
  useEffect( () => {

    let ws = null;

    async function realTime() {

      const token = cookie.load('token');
      const url = `${ WEBSOCKET_HOST }?token=${ token }`;
      console.log(`Попытка подключения к WebSocket, token=${token}`);
      
      ws = WebSocketConnect( url )
      
    }

    realTime();

    return () => {

      if ( ws ) {

        ws.close();

      }
      
    }

  }, []);

  function WebSocketConnect( url ) {

    console.log(`Пытаюсь подключиться к WebSocket-серверу...`)

    const ws = new WebSocket( url );
    let reconnectTimer = undefined;

    ws.onopen = () => {

      console.log(`Успешное подключение к WebSocket-серверу...`)

      ws.send( JSON.stringify({

        client_say: `Успешное подключение к WebSocket-серверу`,
        d: new Date().toLocaleTimeString()

      }));

      reconnectTimer && reconnectTimer.clearInterval();

    }

    ws.onclose = event => {

      // TODO доделать reconnect
      // reconnectTimer = setInterval(() => {

      //   console.log(`Пытаюсь переподключиться к WebSocket-серверу...`);
      //   WebSocketConnect( url );

      // }, 20000 );

    }

    ws.onerror = error => { console.error(`Ошибка WebSocket: `, error ); }

    ws.onmessage = e => {
      
      console.log(`WebSocket.onmessage: `, e );

      let json = null,
          text = null;

      try { json = JSON.parse( e.data ) }
      catch ( ex ) { text = e.data }

      if ( json !== null ) {

        console.log(`WebSocket расшифровал объект: `, json );

        if ( json?.action === "refresh" ) { actions.refreshDeals() }

      } else {

        console.log(`WebSocket расшифровал объект: `, text );

      }

    }

    return ws;

  }

  return null

}

export default WebSockets;